import React, { useEffect, useState } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import WaterMark from "../DashboardMain_Bus/WaterMark";

export default function PieChartAm({ gloablfilter, city, setLegendData }) {
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const [net_consumption, setNetConsumption] = useState([]);
  const net_consumption_resp = (data) => {
    setNetConsumption(data);
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/consumption_fraction_and_factor",
        body: { filterdata: gloablfilter, filtercity: city },
      },
      net_consumption_resp
    );
  }, [gloablfilter]);

  useEffect(() => {
    if (net_consumption.length > 0) {
      let root = am5.Root.new(city);

      // Set themes
      // https://www.amcharts.com/docs/v5/concepts/themes/
      root.setThemes([am5themes_Animated.new(root)]);

      // Create chart
      // https://www.amcharts.com/docs/v5/charts/percent-charts/pie-chart/
      let chart = root.container.children.push(
        am5percent.PieChart.new(root, {
          layout: root.verticalLayout,
          centerX: am5.percent(50),
          x: am5.percent(50),

          paddingTop: 20,
          paddingBottom: 30,
          paddingLeft: 30,
          paddingRight: 15,
        })
      );

      // Create series
      // https://www.amcharts.com/docs/v5/charts/percent-charts/pie-chart/#Series
      let series = chart.series.push(
        am5percent.PieSeries.new(root, {
          valueField: "value",
          categoryField: "category",
          tooltip: am5.Tooltip.new(root, {
            labelText: "[bold]{ti_field}[/]\n({value}%)",
          }),
          legendLabelText: "{category}",
          legendValueText: "",
          alignLabels: false,
        })
      );

      series.labels.template.setAll({
        fontSize: 11,
        // fill: am5.color(0x550000),
        text: "{value}%",
        textType: "radial",
        centerX: am5.percent(15),
        align: "left", // Default alignment, can be adjusted based on conditions

        populateText: true,
        // radius: am5.percent(100),
        // Adjust the position of labels to avoid overlapping
        // populate: (label) => {
        //   let index = series.dataItems.indexOf(label.dataItem);
        //   if (index % 2 === 0) {
        //     label.set("centerY", am5.percent(-30));
        //   } else {
        //     label.set("centerY", am5.percent(30));
        //   }
        // },
      });

      series.ticks.template.setAll({
        stroke: am5.color("#000000"),
        strokeWidth: 2,
        location: 0.8,
      });

      series
        .get("colors")
        .set("colors", [
          am5.color("#3e689f"),
          am5.color("#ff6600 "),
          am5.color("#808080 "),
          am5.color("#FCCF55 "),
          am5.color("#91aed4 "),
          am5.color("#30895E "),
          am5.color("#02055A "),
        ]);
      series.slices.template.setAll({
        sepia: 1,
        brightness: 0.5,
        stroke: am5.color("#fff"),
      });

      // https://www.amcharts.com/docs/v5/charts/percent-charts/pie-chart/#Setting_data
      series.data.setAll([
        {
          value:
            net_consumption[0]["Traction_fr"] !== undefined
              ? net_consumption[0]["Traction_fr"].value.toFixed(2)
              : 0,
          category: "Traction Sys.",
          ti_field:
            net_consumption[0]["Traction System"] !== undefined
              ? Number(net_consumption[0]["Traction System"].value.toFixed(2))
              : 0,
        },
        {
          value:
            net_consumption[0]["HVAC_fr"] !== undefined
              ? net_consumption[0]["HVAC_fr"].value.toFixed(2)
              : 0,
          category: "HVAC",
          ti_field:
            net_consumption[0]["HVAC"] !== undefined
              ? Number(net_consumption[0]["HVAC"].value.toFixed(2))
              : 0,
        },
        {
          value:
            net_consumption[0]["aux1load_fr"] !== undefined
              ? net_consumption[0]["aux1load_fr"].value.toFixed(2)
              : 0,
          category: "AUX-1",
          ti_field:
            net_consumption[0]["Aux-1"] !== undefined
              ? Number(net_consumption[0]["Aux-1"].value.toFixed(2))
              : 0,
        },
        {
          value:
            net_consumption[0]["dcdcLoad_fr"] !== undefined
              ? net_consumption[0]["dcdcLoad_fr"].value.toFixed(2)
              : 0,
          category: "DC-DC",
          ti_field:
            net_consumption[0]["DC-DC"] !== undefined
              ? Number(net_consumption[0]["DC-DC"].value.toFixed(2))
              : 0,
        },
        {
          value:
            net_consumption[0]["aux2load_fr"] !== undefined
              ? net_consumption[0]["aux2load_fr"].value.toFixed(2)
              : 0,
          category: "AUX-2",
          ti_field:
            net_consumption[0]["Aux-2"] !== undefined
              ? Number(net_consumption[0]["Aux-2"].value.toFixed(2))
              : 0,
        },
        {
          value:
            net_consumption[0]["bcs1Load_fr"] !== undefined
              ? net_consumption[0]["bcs1Load_fr"].value.toFixed(2)
              : 0,
          category: "BCS-1",
          ti_field:
            net_consumption[0]["BCS-1"] !== undefined
              ? Number(net_consumption[0]["BCS-1"].value.toFixed(2))
              : 0,
        },
        {
          value:
            net_consumption[0]["bcs2Load_fr"] !== undefined
              ? net_consumption[0]["bcs2Load_fr"].value.toFixed(2)
              : 0,
          category: "BCS-2",
          ti_field:
            net_consumption[0]["BCS-2"] !== undefined
              ? Number(net_consumption[0]["BCS-2"].value.toFixed(2))
              : 0,
        },
      ]);

      series.appear(1000, 100);
      chart.appear(1000, 100);
      root._logo.dispose();
      return () => root.dispose();
    }
  }, [net_consumption]);

  return (
    <>
      <WaterMark />
      <div
        id={city}
        className="energyChartboxNew_Bus"
        style={{ width: "75%", height: "260px" }}
      >
        <span
          style={{ display: "flex", justifyContent: "center", font: "bold" }}
        >
          {city}
        </span>
        {/* <div className="v-title energyTitleChart_Bus pt-2 pb-2 pl-2 text-center">
          <b className=''>Consumption Fraction</b>
        </div> */}
      </div>
    </>
  );
}
